import { idbSet, idbGet, idbDelete, idbGetAllKeys } from './db-storage/db-storage';
import saveToLocalStorage from '@smart-tv/utils/persistent-data/local-storage/set-local-storage';
import removeFromLocalStorage from '@smart-tv/utils/persistent-data/local-storage/remove-local-storage';
import getFromLocalStorage from '@smart-tv/utils/persistent-data/local-storage/get-local-storage';
import { tokenStorage } from '../kmm/kmm';

export function storePersistentData<T>(key: string, value: T, storeIdb = true): void {
  if (storeIdb) {
    idbSet(key, value).catch((error) => {
      console.error(`Error storing data in IndexedDB for key "${key}":`, error);
    });
  }
  saveToLocalStorage(key, value);
}

export function retrievePersistentData<T>(key: string): T | null {
  const value = getFromLocalStorage<T>(key);
  return value;
}

export function removePersistentData(key: string): void {
  idbDelete(key).catch((error) => {
    console.error(`Error removing data from IndexedDB for key "${key}":`, error);
  });
  removeFromLocalStorage(key);
}

export async function ensureLocalStorageMatchIDB(): Promise<void> {
  try {
    if (retrievePersistentData<string>('access_token') !== null) return;

    const keys = await idbGetAllKeys();
    await Promise.all(
      keys.map(async (key) => {
        const value = await idbGet(key);
        if (value !== null) {
          saveToLocalStorage(key, value);
        }
      })
    );

    const accessToken = retrievePersistentData<string>('access_token');
    const refreshToken = retrievePersistentData<string>('refresh_token');

    if (accessToken && refreshToken) {
      tokenStorage.saveTokens(accessToken, refreshToken);
    }
  } catch (error) {
    console.error(`Error loading data from IndexedDB to localStorage: ${error}`);
  }
}
